var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconWarningBorderlessSolid extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconWarningBorderless",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M994.578 1436.356c-133.365 0-241.822 108.457-241.822 241.822S861.213 1920 994.578 1920s241.822-108.457 241.822-241.822-108.457-241.822-241.822-241.822zm170.485-120.912L1310.156 0H679l145.093 1315.444z",
      fillRule: "evenodd"
    })));
  }
}
IconWarningBorderlessSolid.glyphName = 'warning-borderless';
IconWarningBorderlessSolid.variant = 'Solid';
IconWarningBorderlessSolid.displayName = 'IconWarningBorderlessSolid';
IconWarningBorderlessSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconWarningBorderlessSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconWarningBorderlessSolid;
export { IconWarningBorderlessSolid };